import Phone from './Phone'

export default Phone
// eslint-disable-next-line import/export
export * from './Phone'
